import React, { useState, useRef, Component, Fragment } from "react";
import { useReactToPrint } from "react-to-print";
import { useHistory } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import PrintIcon from "@material-ui/icons/Print";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import HomeIcon from "@material-ui/icons/Home";
import { useStylesSpDial } from "../../St/Reviews/UseStyle";
import ShareIcon from "@material-ui/icons/Share";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import { Grid, Typography } from "@material-ui/core";
import { handleDownloadGenratePdf, shareDataPdf, styleContPrint } from "../Invs/ShareFunctionsPrint";
import RevPrintDocCon from "./RevPrintDocCon";
import moment from "moment";
import { Notes } from "@material-ui/icons";
import { downloadInvoicePdf, shareInvoicePdf } from "../Invs/FunctionsPdf";
class ComponentToPrintCashier extends React.Component {
    state = {}
    constructor() {
        super();
    }
    render() {
        const styleCont = { backgroundColor: 'red', width: '80mm', };
        const styleTyg = { backgroundColor: '#FFF', padding: '1mm' };
        return (
            <Grid item container justifyContent='center'>
                <Grid item style={styleCont}>
                    <Typography component="div" style={styleTyg}>
                        <RevPrintDocCon typePrint={this.props.typePrint} openConfirm={this.props.openConfirm}
                            dataPrint={this.props.dataPrint} info={this.props.info} setInfo={this.props.setInfo} />
                    </Typography>
                </Grid>
            </Grid>
        );
    }
}

class ComponentToPrint extends Component {
    constructor() {
        super();
        this.state = {};
    }
    render() {
        const style = {
            backgroundColor: "#fff",
            color: "#000",
        };
        return (
            <Typography component="div" style={style}>
                <RevPrintDocCon typePrint={this.props.typePrint} openConfirm={this.props.openConfirm}
                    dataPrint={this.props.dataPrint} info={this.props.info} setInfo={this.props.setInfo} />
            </Typography>
        );
    }
}
const PrintSafesMain = (props) => {
    const { typePrint, docNamePdf, docName, dataPrint, closePrint } = props
    const componentRef = useRef();
    const reportDownloadRef = useRef();
    const clasSp = useStylesSpDial();
    const [info, setInfo] = useState({});
    const [open, setOpen] = useState(true);
    const [openConfirm, setOpenConfirm] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(true);
    };
    let his = useHistory();

    const back = (path) => {
        if (dataPrint) {
            if (openConfirm) { setOpenConfirm(false); }
            else { closePrint(); }
        } else {
            if (openConfirm) { setOpenConfirm(false); }
            else { path ? his.push({ pathname: "/" }) : his.goBack(); }
        }
    };
    const name_doc = openConfirm || typePrint == 6 ? "AccountConfirm" : docName;
    const name_docPdf = openConfirm || typePrint == 6 ? "AccountConfirm.pdf" : docNamePdf;
    // const shareData = async () => {
    //     shareDataPdf(reportDownloadRef, name_docPdf);
    // };
    // const handleGeneratePdf = async () => {
    //     handleDownloadGenratePdf(name_doc, reportDownloadRef)
    // };
    const shareData = async () => {
        shareInvoicePdf(name_docPdf);
    };
    const handleGeneratePdf = async () => {
        downloadInvoicePdf(name_docPdf);
    };
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        html2canvas: {
            width: 200,
            height: 297,
            scale: 0.75,
        },
    });
    const [childMountCount, setChildMountCount] = useState(0);
    const handleChildMountComplete = () => {
        setChildMountCount((prevCount) => prevCount + 1);
    };

    const printHandleConfirm = () => {
        setOpenConfirm(true);
    };


    const actions = [
        {
            icon: (
                <PrintIcon className={clasSp.ico} onClick={handlePrint} />
            ),
            name: "طباعـة",
        },
        {
            icon: (
                <Notes className={clasSp.ico} onClick={printHandleConfirm} />
            ),
            name: "Accounts Confirm",
            hidden: typePrint != 4 ? true : openConfirm || typePrint === 6 ? true : false,
        },
        {
            icon: (
                <ArrowDownward className={clasSp.ico} onClick={handleGeneratePdf} />
            ),
            name: "تنزيل",
        },
        {
            icon: <ShareIcon className={clasSp.ico} onClick={shareData} />,
            name: "مشاركة",
        },
        {
            icon: (
                <ArrowBackIcon className={clasSp.ico} onClick={() => back(false)} />
            ),
            name: "رجـوع",
        },
    ];

    return (
        <div className={clasSp.root}>
            <Grid item container justifyContent="center" style={styleContPrint}>
                {[11,16].includes(typePrint)?
                    <ComponentToPrintCashier
                        ref={componentRef}
                        onUnmountComplete={handleChildMountComplete}
                        typePrint={typePrint}
                        openConfirm={openConfirm}
                        dataPrint={dataPrint}
                        info={info}
                        setInfo={setInfo}
                    /> :
                    <Grid item style={{ backgroundColor: "#fff", width: "21cm" }}>
                        <CssBaseline />
                        <div
                            ref={reportDownloadRef}
                            lang={"ar"}
                            style={{
                                fontFamily: "Amiri-Regular",
                                fontStyle: "bold",
                                letterSpacing: "normal",
                            }}
                        >
                            <ComponentToPrint
                                ref={componentRef}
                                onUnmountComplete={handleChildMountComplete}
                                typePrint={typePrint}
                                openConfirm={openConfirm}
                                dataPrint={dataPrint}
                                info={info}
                                setInfo={setInfo}
                            />
                        </div>
                    </Grid>
                }
            </Grid>

            <SpeedDial
                ariaLabel="SpeedDial openIcon example"
                className={clasSp.speedDial}
                hidden={false}
                icon={
                    <SpeedDialIcon openIcon={<HomeIcon />} onClick={() => back(true)} />
                }
                onClose={handleClose}
                onOpen={handleOpen}
                open={open}
            >
                {actions.filter(action => !action.hidden).map((action, i) => (
                    <SpeedDialAction
                        key={i}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={handleClose}
                    />
                ))}
            </SpeedDial>
        </div>
    );
};

export default PrintSafesMain;
